import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import './Bank.css';

const url = process.env.REACT_APP_BACKEND_URL;

const EditBank = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  
  const [data, setData] = useState({
    bankname: '',
    bankaccountno: ''
  });

  useEffect(() => {
    const fetchBank = async () => {
      try {
        const response = await axios.get(`${url}/api/bank/${id}`);
        const bank = response.data.data;
        setData({
          bankname: bank.bankname,
          bankaccountno: bank.bankaccountno
        });
      } catch (error) {
        toast.error('Failed to load bank data');
        navigate('/ViewBank');
      } finally {
        setLoading(false);
      }
    };
    fetchBank();
  }, [id, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!data.bankname?.trim()) {
      toast.error('Bank Name is required');
      return;
    }
    if (!data.bankaccountno?.trim()) {
      toast.error('Bank Account Number is required');
      return;
    }

    setSubmitting(true);

    try {
      const response = await axios.put(`${url}/api/bank/${id}`, data);
      
      if (response.data.success) {
        toast.success('Bank updated successfully!');
        navigate('/ViewBank');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to update bank');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <div className="loading">Loading bank...</div>;

  return (
    <div className="bank-container">
      <div className="header">
        <h2>Edit Bank</h2>
        <button onClick={() => navigate('/ViewBank')} className="add-button">
          Back to List
        </button>
      </div>

      <form className="bank-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Bank Name *</label>
          <input
            type="text"
            name="bankname"
            value={data.bankname}
            onChange={handleChange}
            placeholder="Enter bank name"
            required
          />
        </div>

        <div className="form-group">
          <label>Phone Number *</label>
          <input
            type="text"
            name="bankaccountno"
            value={data.bankaccountno}
            onChange={handleChange}
            placeholder="Enter bank account number"
            required
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="submit-button" disabled={submitting}>
            {submitting ? "Updating..." : "Update Bank"}
          </button>
          <button
            type="button"
            onClick={() => navigate('/ViewBank')}
            className="cancel-button"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditBank;